import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { SelectForm } from 'components/Form/components'
import { Button } from 'ui-components/Button'
import Search from '@material-ui/icons/Search'
import { FormContainer, Filters, ButtonContainer } from './styles'

export default function SearchForm(props) {
  const {
    manufacturers,
    onSearch,
  } = props

  const [selected, setSelected] = useState({ value: '' })

  const handleSubmit = (evt) => {
    evt.preventDefault()
    onSearch(selected.value)
  }

  const handleChangeSelect = (value) => {
    setSelected(value)
  }

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Filters>
        <SelectForm
          options={manufacturers}
          onChange={handleChangeSelect}
          value={selected}
          label="Fabricante"
          name="manufacturer_id"
        />
      </Filters>
      <ButtonContainer>
        <Button
          type="submit"
          buttonType="icon"
          size="small"
        >
          <Search />
        </Button>
      </ButtonContainer>
    </FormContainer>
  )
}

SearchForm.propTypes = {
  manufacturers: PropTypes.arrayOf(PropTypes.object),
  onSearch: PropTypes.func.isRequired,
}

SearchForm.defaultProps = {
  manufacturers: [],
}
